// Google Calendar "add event" link builder (research §7.5 — calendar blocking
// predicts recalibration completion). Opens the prefilled Google Calendar
// event-creation page; no auth or API needed.

function toCalDate(d: Date): string {
  // YYYYMMDDTHHMMSSZ (UTC)
  return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

export function googleCalendarUrl(opts: {
  title: string;
  details?: string;
  start: Date;
  durationMinutes?: number;
}): string {
  const end = new Date(opts.start.getTime() + (opts.durationMinutes ?? 15) * 60_000);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: opts.title,
    dates: `${toCalDate(opts.start)}/${toCalDate(end)}`,
    details: opts.details ?? '',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/** A Date `days` from now at 10:00 local time — a sensible default reminder slot. */
export function daysFromNowAt10(days: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + days);
  d.setHours(10, 0, 0, 0);
  return d;
}
